import { render, staticRenderFns } from "./downTip.vue?vue&type=template&id=4bac70c1&scoped=true&"
import script from "./downTip.vue?vue&type=script&lang=js&"
export * from "./downTip.vue?vue&type=script&lang=js&"
import style0 from "./downTip.vue?vue&type=style&index=0&id=4bac70c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac70c1",
  null
  
)

export default component.exports